import React from "react";

interface IframeContentProps {
  src: string;
  id?: string;
  className?: string;
  title?: string;
  onLoad?: (event: any) => void;
  onError?: () => void;
}

const IframeContent: React.FC<IframeContentProps> = ({ src, id, className, title, onLoad, onError }) => {
  return <iframe src={src} id={id} className={className} title={title} onLoad={onLoad} onError={onError} />;
};

export default IframeContent;
